/** The support chat: a merchant's conversations with the NeonCarts team. */
const supportChat: Record<string, string> = {
  title: 'Support',
  description: 'Talk to the NeonCarts team. Open a conversation, attach a screenshot if it helps, and we reply here.',
  new: 'New conversation',
  'list.aria_label': 'Conversations',
  'list.search_label': 'Search conversations',
  'list.search_placeholder': 'Search by subject',
  'list.empty_title': 'No conversations yet',
  'list.empty_description': 'Stuck on something? Start a conversation and a member of the team will reply here.',
  'filter.aria_label': 'Filter conversations',
  'filter.open': 'Open',
  'filter.resolved': 'Resolved',
  'filter.closed': 'Closed',
  'filter.all': 'All',
  'status.OPEN': 'Waiting for our reply',
  'status.WAITING_MERCHANT': 'Replied',
  'status.RESOLVED': 'Resolved',
  'status.CLOSED': 'Closed',
  unread_count: '{count} unread',
  'dialog.title': 'New conversation',
  'dialog.subject_label': 'Subject',
  'dialog.subject_placeholder': 'What is it about?',
  'dialog.body_label': 'Message',
  'dialog.body_placeholder': 'Tell us what happened, what you expected, and where in the dashboard you were.',
  'dialog.submit': 'Send',
  'dialog.cancel': 'Cancel',
  'thread.aria_label': 'Messages',
  'thread.select_title': 'Pick a conversation',
  'thread.select_description': 'Choose one from the list, or start a new one.',
  'thread.empty': 'Nothing here yet.',
  'thread.load_older': 'Load older messages',
  'thread.back': 'Back to conversations',
  'thread.resolve': 'Mark resolved',
  'thread.answered_by': 'Answered by {name}',
  'thread.unassigned': 'Waiting for a member of the team',
  'thread.resolved_note': 'This conversation is resolved. Reply to reopen it.',
  'thread.closed_note': 'This conversation is closed. Start a new one to continue.',
  'thread.you': 'You',
  'thread.team': 'NeonCarts team',
  'composer.label': 'Reply',
  'composer.placeholder': 'Write a reply…',
  'composer.send': 'Send',
  'composer.sending': 'Sending…',
  'composer.uploading': 'Uploading {count} file(s)… {percent}%',
  'composer.attach': 'Attach a file',
  'composer.attach_hint': 'PNG, JPG, GIF, WebP or PDF, up to 10 MB each, five per message. You can also paste a screenshot (Ctrl+V).',
  'composer.pasted': '{count} pasted file(s) attached.',
  'composer.remove_file': 'Remove {name}',
  'composer.read_only': 'You can read this conversation but not reply from this account.',
  'attachment.open': 'Open {name}',
  'attachment.download': 'Download {name}',
  'bell.label': 'Support replies',
  'bell.label_unread': 'Support replies, {count} unread',
  'bell.title': 'Replies from the NeonCarts team',
  'bell.empty': "You're all caught up.",
  'bell.error': 'Replies could not be loaded.',
  'bell.open_support': 'Open Support',
  'bell.toast': 'The NeonCarts team replied',
  'bell.toast_open': 'Open',
  'errors.generic': 'Something went wrong. Please try again.',
  'errors.not_found': 'That conversation could not be found.',
  'errors.file_type': '{name} is not a PNG, JPG, GIF, WebP or PDF file.',
  'errors.file_size': '{name} is over 10 MB.',
  'errors.file_count': 'You can attach up to five files to one message.',
  'errors.SUPPORT_CONVERSATION_CLOSED': 'This conversation is closed. Start a new one to continue.',
  'errors.SUPPORT_ATTACHMENT_INVALID_TYPE': 'Attachments must be PNG, JPG, GIF, WebP images or PDF files.',
  'errors.SUPPORT_ATTACHMENT_TOO_LARGE': 'Each attachment must be under 10 MB.',
  'errors.SUPPORT_TOO_MANY_ATTACHMENTS': 'At most five files can be sent with one message.',
  'errors.SUPPORT_MESSAGE_EMPTY': 'Write a message or attach a file.',
};

export default supportChat;
